import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArticles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 6,
		fill: "#24A2C2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.5 11H13.5C13.279 11 13.067 11.0878 12.9108 11.2441C12.7545 11.4004 12.6667 11.6123 12.6667 11.8334V15.1667C12.6667 15.3877 12.7545 15.5997 12.9108 15.7559C13.067 15.9122 13.279 16 13.5 16H18.5C18.721 16 18.933 15.9122 19.0893 15.7559C19.2455 15.5997 19.3333 15.3877 19.3333 15.1667V11.8334C19.3333 11.6123 19.2455 11.4004 19.0893 11.2441C18.933 11.0878 18.721 11 18.5 11ZM17.6667 14.3334H14.3333V12.6667H17.6667V14.3334ZM20.1667 7.66669H10.1667C9.94566 7.66669 9.7337 7.75448 9.57742 7.91076C9.42114 8.06704 9.33334 8.27901 9.33334 8.50002V23.5C9.33334 23.721 9.42114 23.933 9.57742 24.0893C9.7337 24.2456 9.94566 24.3334 10.1667 24.3334H20.1667C20.8297 24.3334 21.4656 24.07 21.9344 23.6011C22.4033 23.1323 22.6667 22.4964 22.6667 21.8334V10.1667C22.6667 9.50365 22.4033 8.86776 21.9344 8.39892C21.4656 7.93008 20.8297 7.66669 20.1667 7.66669ZM21 21.8334C21 22.0544 20.9122 22.2663 20.7559 22.4226C20.5997 22.5789 20.3877 22.6667 20.1667 22.6667H11V9.33335H20.1667C20.3877 9.33335 20.5997 9.42115 20.7559 9.57743C20.9122 9.73371 21 9.94567 21 10.1667V21.8334Z",
		fill: "#DFF1FA"
	})]
});
export default SvgArticles;
